
import {mpx} from '@didi/es-mpx-creator'
import { TRAIN_CUSTOMER_SERVICE } from './urls';

export const getCustomerService = () => {
  return mpx.$http.post(
    TRAIN_CUSTOMER_SERVICE
  )
}


